<template>
    <div :class="cssClass" :style="style" @click="e => this.$emit('click', e)">
        <slot>
            {{ content }}
            <img v-if="showImage" :src="image" :alt="text" />
        </slot>
    </div>
</template>
<script>
export default {
    name: 'NavigationButton',
    props: {
        icon: {
            type: String,
            default() {
                return ''
            },
        },
        image: {
            type: String,
            default() {
                return ''
            },
        },
        text: {
            type: String,
            default() {
                return ''
            },
        },
        angle: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        showIcon() {
            return this.icon && this.icon.length > 0
        },
        showImage() {
            return !this.showIcon && this.image && this.image.length > 0
        },
        showText() {
            return !this.showIcon && !this.showImage
        },
        content() {
            if (this.showIcon) {
                return this.icon
            }

            if (this.showText) {
                return this.text
            }

            return ''
        },
        cssClass() {
            return this.showIcon ? 'material-icons navigation-button' : 'navigation-button navigation-button-text'
        },
        style() {
            return this.angle ? { transform: `rotate(${this.angle}deg)` } : ''
        },
    },
}
</script>
<style>
.navigation-button {
    background-color: var(--color-light-background);
    border-radius: calc(var(--navigation-button-size) / 2);
    color: var(--color-navigation-button-text);
    cursor: pointer;
    display: inline-block;
    height: var(--navigation-button-size);
    line-height: var(--navigation-button-size);
    text-align: center;
    width: var(--navigation-button-size);

    &.navigation-button-text {
        font-size: var(--font-size-nav-text);
        font-weight: var(--weight-heavy);
    }

    &.material-icons {
        line-height: var(--navigation-button-size);
    }

    &:hover {
        background-color: var(--color-navigation-button-hover);
    }
}
</style>
